// eventDefinitions.js

export const ANALYTICS_EVENTS = {
  SESSION_START: "custom_session_start",
  SESSION_DURATION: "custom_session_duration",
  NEW_USER: "custom_new_user",
  PAGE_VIEW: "custom_page_view",
  FIRST_FIRESTORE_WRITE: "custom_first_firestore_write",
  FEATURE_USAGE: "custom_feature_usage",
  STRIPE_ACTIONS: "custom_stripe_actions",
};

export const ANALYTICS_PARAMS = {
  USER_ID: "user_id",
  SUBSCRIPTION_STATUS: "subscription_status",
  DEVICE_TYPE: "device_type",
  TRIAL_START: "trial_start",
  TRIAL_END: "trial_end",
  DURATION: "duration",
  PAGE_TITLE: "page_title",
  DATE: "date",
  FEATURE: "feature",
  CONVERSION_TYPE: "conversion_type",
  ACTION: "action",
  NUM_CLIENTS: "num_clients",
};
